import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "disabled"];
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { DeleteIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const DeleteMetricButton = _ref => {
  let {
      onClick,
      disabled = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(IconButton, Object.assign({}, rest, {
    onClick: onClick,
    disabled: disabled,
    use: "transparent",
    paddingInlineStart: "0",
    "aria-label": "Delete property",
    children: /*#__PURE__*/_jsx(DeleteIcon, {
      size: "400"
    })
  }));
};
export default DeleteMetricButton;